import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { ConnectedRouter } from 'connected-react-router';
import moment from 'moment';
import React, { FC, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { QueryClientProvider, QueryClient } from 'react-query';
import { Provider } from 'react-redux';
import { CKEditorContext } from 'contexts';
import { CurrentUserProvider, AccountProvider } from 'contexts/providers';
import { store, history } from 'data';
import { localeData } from 'translations/en-moment';
import translations from 'translations/en.json';
import { InsertResourcelistTemplateRenderProps } from '../resource-list-templates-section';
import { ResourceSectionPlaceholder } from './resource-section-placeholder';
import { ResourceSectionProps } from './types';

export const ResourceSection: FC<ResourceSectionProps> = ({ config }) => {
  const locale = 'en';

  useLayoutEffect(() => {
    moment.updateLocale(locale, localeData);
  }, [locale]);

  return (
    <AccountProvider>
      <CurrentUserProvider>
        <ResourceSectionPlaceholder config={config} />
      </CurrentUserProvider>
    </AccountProvider>
  );
};
const queryClient = new QueryClient();

// This is used by CK to render the resource section template so that server can use this to populate data
export const resourceSectionTemplateRenderer = (
  {
    resourceTemplateSectionId,
    resourceTemplateSectionType,
    resourceTemplateSectionFilterType,
    resourceTemplateSectionFilterWeeksRange,
    resourceTemplateSectionFilterRangeStr,
  }: InsertResourcelistTemplateRenderProps,
  container: HTMLElement,
  editor: Editor,
): void => {
  const locale = 'en';

  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <IntlProvider locale={locale} messages={translations}>
          <QueryClientProvider client={queryClient}>
            <CKEditorContext.Provider value={editor}>
              <ResourceSection
                config={{
                  resourceTemplateSectionId,
                  resourceTemplateSectionType,
                  resourceTemplateSectionFilterType,
                  resourceTemplateSectionFilterWeeksRange,
                  resourceTemplateSectionFilterRangeStr,
                }}
              />
            </CKEditorContext.Provider>
          </QueryClientProvider>
        </IntlProvider>
      </ConnectedRouter>
    </Provider>,
    container,
  );
};
